import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook, Twitter } from 'lucide-react';
import { useSiteContent } from '../context/SiteContentContext';

const LOGO_URL = "/images/logo.png";

const Footer = () => {
  const { siteContent } = useSiteContent() || {};
  const phone = siteContent?.contact?.phone || '+91 96496 11111';
  const phoneTel = phone.replace(/\s/g, '');
  const email = siteContent?.contact?.email || 'info@rudragarh.com';
  const address = siteContent?.contact?.address || 'Rudragarh Resort, Village Damodra, Sam Road, Jaisalmer, Rajasthan 345001';

  return (
    <footer className="bg-void-paper border-t border-gold-500/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <img src={LOGO_URL} alt="Rudragarh" className="h-20 w-auto" />
            <p className="text-foreground/60 text-sm leading-relaxed">
              A Luxury Adventure Retreat in the heart of the Thar Desert. 
              Where rugged exploration meets high-end hospitality.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-foreground/40 hover:text-gold-500 transition-colors" data-testid="footer-instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-foreground/40 hover:text-gold-500 transition-colors" data-testid="footer-facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-foreground/40 hover:text-gold-500 transition-colors" data-testid="footer-twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg text-gold-500 mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'The Stay', path: '/stay' },
                { name: 'Experiences', path: '/experiences' },
                { name: 'Dining', path: '/dining' },
                { name: 'Gallery', path: '/gallery' },
                { name: 'About', path: '/about' },
                { name: 'Book Now', path: '/book' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground/60 hover:text-gold-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Accommodations */}
          <div>
            <h4 className="font-heading text-lg text-gold-500 mb-6">Accommodations</h4>
            <ul className="space-y-3">
              {[
                { name: 'The Catacomb Suite', slug: '/stay/catacomb-suite' },
                { name: 'Cascade Cottages', slug: '/stay/cascade-cottages' },
                { name: 'The Heritage Huts', slug: '/stay/heritage-huts' },
                { name: 'The Desert Riad Suite', slug: '/stay/desert-riad-suite' },
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.slug}
                    className="text-foreground/60 hover:text-gold-500 transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg text-gold-500 mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-gold-500 mt-1 flex-shrink-0" />
                <span className="text-foreground/60 text-sm">{address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-gold-500 flex-shrink-0" />
                <a href={`tel:${phoneTel}`} className="text-foreground/60 hover:text-gold-500 transition-colors text-sm">
                  {phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-gold-500 flex-shrink-0" />
                <a href={`mailto:${email}`} className="text-foreground/60 hover:text-gold-500 transition-colors text-sm">
                  {email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-gold-500/10 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-foreground/40 text-sm">
            © {new Date().getFullYear()} Rudragarh. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-foreground/40 hover:text-gold-500 transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-foreground/40 hover:text-gold-500 transition-colors text-sm">
              Terms &amp; Conditions
            </Link>
            <Link to="/refund-cancellation" className="text-foreground/40 hover:text-gold-500 transition-colors text-sm">
              Refund &amp; Cancellation
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
